import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Authentication from "../../../componant/authentication/authentication";
import { Riple } from "react-loading-indicators";

import LearnPlan from "../userPanal/Plans/LearnPlan";
import Checkoutpage from "../userPanal/Plans/Checkoutpage";
import Maincontest from "../userPanal/contest/Maincontest";
import DummyContest from "../userPanal/contest/dummyContest";
import Wallet from "../wallet/Wallet";
import StartQuizepage from "../userPanal/Mcq/StartQuizepage";
import QuestionPage from "../userPanal/Mcq/QuestionPage";
import DashHome from "../userPanal/dashhome/DashHome";
import ContestQuestion from "../userPanal/contestMCQ/ContestQuestion";
import WinnersPage from "../userPanal/contest/WinnersPage";
import ContestAnswerKey from "../userPanal/contest/ContestAnswerKey";
import WithDrawHistory from "../withdraw/WithHistory";
import ContestWallet from "../wallet/ContestWallet";
import ContestWithDrawHistory from "../withdraw/ContestWithHistory";
import ReferralWallet from "../wallet/ReferralWallet";
import StartQuizepage2 from "../userPanal/Mcq/StartQuizepage2";

import ContestResultPage from "../userPanal/contest/ContestResultPage";
import WithdrawalHistory from "../wallet/WithdrawalHistory";
import ReferralPage from "../referral/ReferralPage";
// chat route
import ChatMessage from '../../chat/ChatMessage'
import InviteFriend from "../referral/InviteFriend";
import Support from "../../support/Support";
import ProfileNew from "../profile/ProfileNew";
import KycStatus from "../profile/KycStatus";
import BankDetails from "../profile/BankDetails";
import Security from "../profile/Security";
import Organisation from "../profile/Organisation";
import TransactionHistory from "../../../components/Wallet/TransactionHistory";
import CurrentAffairs from "../currentAffairs/CurrentAffairs";
import StateGk from "../stateGk/StateGk";
import LeaderBoard from "../leaderBoard/LeaderBoard";
import SelectExam from "../userPanal/exam/SelectExam";
import MockTestFlow from "../userPanal/mockTest/MockTestFlow";
import MockTestsAll from "../userPanal/mockTest/MockTestsAll";
import MockTestDetails from "../userPanal/mockTest/MockTestDetails";
import MyMockTestDetails from "../userPanal/mockTest/MyTestDetails";
import MockTestLeaderboard from "../userPanal/mockTest/MockTestLeaderboard";
import MockTestResult from "../userPanal/mockTest/MockTestResult";
import MyTestsAll from "../userPanal/mockTest/MyTestsAll";
import MyTestFlow from "../userPanal/mockTest/MyTestFlow";
import MyTestResult from "../userPanal/mockTest/MyTestResult";
import Lectures from "../userPanal/lectures/Lectures";
const DashRoute = () => {
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const location = useLocation();
 
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust timeout as needed

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <Authentication>
        {/* {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
            <Riple color="#000000" size="medium" text="" textColor="" />
          </div>
        )} */}
        <Routes>
          {/* <Route path='/home' element={<MainMcqs />} /> */}
          <Route path="/home" element={<DashHome />} />
          <Route path="/lectures" element={<Lectures />} />
          <Route path="/quize" element={<QuestionPage />} />
          <Route path="/plan" element={<LearnPlan />} />
          <Route path="/checkout/:id" element={<Checkoutpage />} />
          <Route path="/contest" element={<Maincontest />} />
          <Route path="/dummy-contest" element={<DummyContest />} />
          <Route path="/contest-question" element={<ContestQuestion />} />
          <Route path="/contest-winner" element={<WinnersPage />} />
          <Route path="/contest-answer-key" element={<ContestAnswerKey />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/contest-wallet" element={<ContestWallet />} />
          {/* <Route path="/referral" element={<ReferralPage />} /> */}
          <Route path="/referral" element={<InviteFriend />} />
          <Route path="/referral-wallet" element={<ReferralWallet />} />
          <Route path="/withdrawal-history" element={<WithdrawalHistory />} />
          {/* support */}
          <Route path="/support" element={<Support />} />
          <Route path="/withdraw-history" element={<WithDrawHistory />} />
          <Route
            path="/contest-withdraw-history"
            element={<ContestWithDrawHistory />}
          />
          {/* <Route path='/start-quize' element={<StartQuizepage />} /> */}
          <Route path="/start-quize" element={<StartQuizepage2 />} />
          <Route path="/contest-result" element={<ContestResultPage/>} />

          {/* chat route */}
          <Route path="/chat" element={<ChatMessage />} />
          {/* Profile route */}
          <Route path="/profileNew" element={<ProfileNew />} />
          <Route path="/organisation" element={<Organisation />} />
          <Route path="/kyc-status" element={<KycStatus />} />
          <Route path="/bank-details" element={<BankDetails />} />
          <Route path="/security" element={<Security />} />
          <Route path="/transaction-history" element={<TransactionHistory />} />
          <Route path="/current-affairs" element={<CurrentAffairs />} />

          {/* state GK route */}
          <Route path="/state-gk" element={<StateGk />} /> 
          {/* leader board route */}
          <Route path="/leaderBoard" element={<LeaderBoard />} /> 
          {/* Exam Route */}
          <Route path="/select-exam" element={<SelectExam />} />
          <Route path="/mock-tests" element={<MockTestsAll />} />
          <Route path="/my-mock-tests" element={<MyTestsAll />} />
          <Route path="/my-test-details/:mockTestId" element={<MyMockTestDetails />} />
          <Route path="/my-test/:mockTestId" element={<MyTestFlow />} />
          <Route path="/my-test-result/:mockTestId" element={<MyTestResult />} />
          <Route path="/mock-test-details/:mockTestId" element={<MockTestDetails />} />
          <Route path="/mock-test-leaderboard/:mockTestId" element={<MockTestLeaderboard />} />
          <Route path="/mock-test-result/:mockTestId" element={<MockTestResult />} />
          <Route path="/mock-test/:courseId" element={<MockTestFlow />} />
          <Route path="*" element={<Navigate to="/dash/home" replace />} />
        </Routes>
        
      </Authentication>
    </>
  );
};

export default DashRoute;
